<template>
  <div id="jobs">
    <myhead></myhead>
    <div class="bar">
      <router-link to="/">Fountain-scientific Home Page</router-link>
      <span>></span>
      <router-link to="/jobs">Job Offer</router-link>
	  </div>
    <div class="box">
      <p class="title">Job Offer</p>
      <div class="content">
        <div class="h">
          Job Offer:
        </div>
        <div class="job" v-for="(item,index) in jobs" :key="index">
          <div class="job-key">
            <p>Job Name: </p>    
            <p class="info">{{item.name}}</p>                        
          </div>
          <div class="job-key">
            <p> Job Responsibilities: </p>
            <ul class="info">
              <li v-for="(res,index) in item.res" :key="index">
                {{index+1}}、{{res}}
              </li>
            </ul>
          </div>
          <div class="job-key">
            <p> Job Rquirements:</p>
            <ul class="info">
              <li v-for="(req,index) in item.req" :key="index">
                {{index+1}}、{{req}}
              </li>
            </ul>
          </div>
          <div class="job-key">
            <p> Working Place: </p>
            <p class="info">{{item.place}}</p>
          </div> 
        </div>
         
      </div>
    </div> 
  </div>
</template>

<script>
import myhead from "./common/header.vue";
import axios from "axios";
const url = require("../url").url;
export default {
  name: "Jobs",
  components: {
    myhead
  },
  created() {
    //获取招聘信息
    axios
      .get(url.employments)
      .then(response => {
        let data = response.data.data;
        this.jobs = data;       
      })
      .catch(error => {
        console.log(error);
        alert("Error");
      });
  },
  data() {
    return {
      jobs:[]
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/css/style.less");

.bar {
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 14px;
  padding: 0 10%;
  margin: 20px 0;
}
.bar > span {
  margin: 0 10px;
}
.box {
  padding: 0 10%;
  margin-bottom: 50px;
}
.title {
  height: 40px;
  color: #fff;
  line-height: 40px;
  background-color: @indexTheme;
}
.content {
  box-sizing: border-box;
  background-color: #eeeeee;
  padding: 50px 50px;
}
.h {
  border-bottom: 1px #ccc dotted;
  line-height: 40px;
  height: 40px;
  text-align: left;
  font-size: 14px;
  margin-bottom: 10px;
}
.job-key {
  display: flex;
  margin: 10px 0;
}
.job-key > p:first-child {
  width: 200px;
  text-align: right;
  margin-right: 20px;
}
.info > li {
  margin-bottom: 8px;
}
.job {
  border-bottom: 1px #ccc dotted;
  padding-bottom: 30px;
  padding-top: 30px;
  text-align: left;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs.vue